import React from 'react';
import { BizonSidebar, Button } from 'components/commons';
import bizMitoIcon from 'assets/svg/biz-mito.svg';
import { useGetLoanQuery } from 'generated/graphql';
import { getLoanApplicationParams } from 'utils/utils';

const Approval: React.FC = (): JSX.Element => {
    const loanApplicationId  = getLoanApplicationParams();

    const { data } = useGetLoanQuery({
        variables:{
            id:loanApplicationId
        },
        fetchPolicy:"network-only"
    });

    const handleSubmit = () => {
        window.open(
            'https://bizcapital.com.br/central-de-ajuda/como-e-realizada-a-assinatura-do-contrato-de-emprestimo/'
        );
    };

    return (
        <div className="bizon-checkout grid-container">
            <BizonSidebar
                loanApplication={data?.loanApplication}
                className="bizon-checkout__sidebar"
                boxTitle={<>seu empréstimo na biz 🌟</>}
            />
            <div className="bizon-checkout__approval">
                <img
                    width={200}
                    alt="BizMito"
                    src={bizMitoIcon}
                />

                <h2 className="title-1 text-primary mb-4">deu biz!</h2>

                <p className="body-1">
                    Seu empréstimo foi aprovado!
                    <br />
                    vamos assinar o contrato?
                </p>
            </div>
            <div className="bizon-checkout__footer">
                <Button
                    className="w-auto"
                    label="como assinar o contrato"
                    onClick={handleSubmit}
                />
            </div>
        </div>
    );
};

export default Approval;
